import { render, staticRenderFns } from "./shopOtoldTemplateEdit.vue?vue&type=template&id=5740f66b&"
import script from "./shopOtoldTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./shopOtoldTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports